import { Anchor, Badge } from '@mantine/core';

const BadgeWithIcon = ({ icon: Icon, href, title }) => {
  return (
    <Badge variant="light" color="gray" size="xs" tt="none" style={{ overflow: 'visible' }}>
      <Anchor href={href} target="_blank" rel="noreferrer" c="dark.6" size="xs" style={{ textDecoration: 'none' }}>
        <Icon size={12} /> {title}
      </Anchor>
    </Badge>
  );
};

export default BadgeWithIcon;
